import { useEffect, useState } from "react";
import { getLocalParameters } from "src/helpers/AppCode";
import IdleLogoutAlert from "./IdleLogoutAlert"
import { isTokenExpired } from "src/helpers/AppCode";
import { DefaultParameters } from "src/store/GlobalParameters/DefaultParameters";

const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
  ];

function IddleLogout(props: iddleLogoutProps) {
    const defaultParams = DefaultParameters();
    const [parameters, setParameters] = useState<LocalParameters>(defaultParams);
    const [showAlert, setShowAlert] = useState<boolean>(false);

    let timer: ReturnType<typeof setTimeout>;

    function handleLogoutTimer(time: number) {
        timer = setTimeout(() => {
          // clears any pending timer.
          resetTimer();
          // Listener clean up. Removes the existing event listener from the window
          Object.values(events).forEach((item) => {
              window.removeEventListener(item, resetTimer);
          });
          // logs out user
          const tokenAuthUser = localStorage.getItem(`${process.env.REACT_APP_BASENAME}_authUser`);
          !isTokenExpired(tokenAuthUser) && setShowAlert(true)
          //logoutAction()
        }, time);

      };

      function resetTimer() {
        if (timer) clearTimeout(timer);
      };

      function logoutAction() {
        const defaultBasename = process.env.REACT_APP_BASENAME;

        resetTimer();
        localStorage.clear();
        window.location.pathname = `/${defaultBasename}/logout`;
      };

      useEffect(() => {
        const fetchData = async () => {
          const parameters = await getLocalParameters();
          setParameters(parameters);
        };

        fetchData();
      }, []);

      useEffect(() => {
        let isMounted = true;

        handleLogoutTimer(parameters.logoutIdle.logoutTime);
        if(props.protectedRoute && !showAlert && parameters.logoutIdle.enable){
          Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
              resetTimer();
              handleLogoutTimer(parameters.logoutIdle.logoutTime);
            });
          });
        }

        resetTimer();
        return () => { isMounted = false };
      }, [parameters])

      return <>
        {showAlert && parameters.logoutIdle &&
          <IdleLogoutAlert
            isOpen={showAlert}
            autoCloseTimer={parameters.logoutIdle.cancelModalTime}
            userCloseAction={() => setShowAlert(false)}
            autoCloseAction={logoutAction}
          />
        }
      </>
}

export default IddleLogout

interface iddleLogoutProps{
  protectedRoute: boolean;
}
